<template>
  <x-page
    :loading="loading"
    :title="topicData.commodityGroupTitle"
    :transparent-header="true"
    :enable-header-parallax="true"
  >
    <template v-if="!loading" #header="{ headerParallaxRate, handleBackClick }">
      <div
        class="header"
        :style="{
          backgroundColor:
            headerParallaxRate === 0
              ? 'transparent'
              : `rgba(255, 255, 255, ${headerParallaxRate})`,
        }"
      >
        <!-- 返回 -->
        <div
          class="back"
          :style="{
            color: headerParallaxRate ? 'black' : 'white',
          }"
          @click="handleBackClick"
        >
          <x-icon name="back" class="icon" />
        </div>
        <!-- 标题 -->
        <div
          class="title"
          :style="{
            color:
              headerParallaxRate === 0
                ? 'transparent'
                : `rgba(0, 0, 0, ${headerParallaxRate})`,
          }"
        >
          {{ topicData.commodityGroupTitle }}
        </div>
        <!-- 搜索 -->
        <div
          v-track="{
            name: '多多商城搜索框',
            id: '0b23bd64-c6e0-4902-b222-f43c4b141f95',
          }"
          class="search"
          :style="{
            backgroundColor: `rgba(255, 255, 255, ${1 - headerParallaxRate})`,
          }"
          @click="handleSearchClick"
        >
          <x-icon name="search" class="icon" />
        </div>
      </div>
    </template>
    <template v-if="!loading">
      <!-- 头图 -->
      <div class="headImage">
        <img :src="topicData.commodityGroupBackgroundPic" class="cover" />
      </div>

      <!-- 搜索栏 -->
      <van-sticky :offset-top="pageHeaderHeight">
        <div class="searchBar">
          <!-- 分组栏 -->
          <div v-if="groupData.length > 2" class="groupBar">
            <van-tabs v-model="groupIndex" class="tabs">
              <van-tab v-for="item in groupData" :key="item.value">
                <div
                  slot="title"
                  v-track="{
                    name: '商品分组',
                    id: '065430cc-889d-486c-a47a-cbd2f7e1a54d',
                    resource: {
                      id: item.id,
                      name: item.label,
                    },
                  }"
                  class="item"
                >
                  <van-image
                    :src="item.icon"
                    fit="cover"
                    lazy-load
                    class="icon"
                  />
                  <div class="name">{{ item.label }}</div>
                </div>
              </van-tab>
              <van-tab />
            </van-tabs>
            <x-pick-sheet
              v-model="groupIndex"
              v-track="{
                name: '更多分类',
                id: '67b646ca-6f80-4d71-8be0-20d943792461',
              }"
              title="更多分类"
              :data="groupData"
              class="more"
              :col-count="5"
            >
              <template #item="{ item, pick, picked }">
                <div
                  :key="item.value"
                  v-track="{
                    name: '商品分组',
                    id: '065430cc-889d-486c-a47a-cbd2f7e1a54d',
                    resource: {
                      id: item.id,
                      name: item.label,
                    },
                  }"
                  :class="['pickGroupItem', picked && 'picked']"
                  @click="pick"
                >
                  <x-icon :src="item.icon" class="icon" />
                  <div class="name">{{ item.label }}</div>
                </div>
              </template>
              <div>更多</div>
              <div>分类</div>
            </x-pick-sheet>
          </div>
          <!-- 筛选栏 -->
          <x-goods-filter-bar v-model="filterForm" class="filterBar" />
        </div>
      </van-sticky>

      <!-- 商品列表 -->
      <x-swipeable-view
        :key="groupIndex"
        class="goodsList"
        :index="groupIndex"
        :total="groupData.length"
        @swipe="({ index }) => (groupIndex = index)"
      >
        <x-goods-waterfall
          ref="goodsList"
          :load="handleLoadData"
          :track="{
            from: '商品专题',
          }"
        />
      </x-swipeable-view>

      <!-- 购物车 -->
      <x-float-cart />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiCommodityCommodityGroupBaseInfo,
    apiCommodityCommodityGroupCommodityClassifyList,
    apiCommodityCommodityGroupCommodityList,
    apiSearchMartSearchSearchCommodity,
  } from '@/api'
  import { currentMall } from '@/mall'
  import { mapQuery, prepareData, Track } from '@/utils'
  import { navigateTo } from '@/router'
  import { uniq } from 'vtils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        id: 'id',
        groupId: 'groupId',
      }),
      Track.provideMark(function () {
        return new Promise(resolve => {
          const off = this.$watch(
            () => this.topicData,
            () => {
              if (this.topicData.id) {
                off?.()
                resolve({
                  page: '专题页',
                  id: this.topicData.id,
                  name: this.topicData.commodityGroupTitle,
                })
              }
            },
            {
              immediate: true,
            },
          )
        })
      }),
    ],

    data: () => ({
      loading: true,
      topicData: {},
      groupData: [],
      groupIndex: 0,
      filterForm: {
        orderBy: 'none',
        orderType: 'none',
      },
    }),

    watch: {
      groupIndex() {
        this.$reloadWaterfall('goodsList')
      },
      filterForm() {
        this.$reloadWaterfall('goodsList')
      },
    },

    mounted() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { topicData, groupData } = await prepareData({
          topicData: apiCommodityCommodityGroupBaseInfo({
            id: this.id,
          }),
          groupData: apiCommodityCommodityGroupCommodityClassifyList({
            id: this.id,
          }).then(async res => [
            {
              label: '推荐',
              value: 0,
              icon: 'https://dcb-frontend.oss-cn-chengdu.aliyuncs.com/demo/x/1629884907jEq7K1.png',
              id: undefined,
              useSearchApi: false,
              searchCategoryIds: [],
            },
            ...(await Promise.all(
              res.map(async (item, index) => ({
                label: item.classifyTitle,
                value: index + 1,
                icon: item.classifyPic,
                id: item.id,
                useSearchApi: item.dataSource === 1,
                searchCategoryIds:
                  item.dataSource === 1
                    ? await apiCommodityCommodityGroupCommodityList({
                        id: this.id,
                        classifyId: item.id,
                        pageIndex: 1,
                        pageSize: 20,
                        priceSortType: 0,
                        salesSortType: 0,
                      }).then(res =>
                        uniq(
                          (res.list || [])
                            .map(item => item.refCategoryId)
                            .filter(Boolean),
                        ),
                      )
                    : [],
              })),
            )),
          ]),
        })
        this.topicData = topicData
        this.groupData = groupData
        const groupIndex = groupData.findIndex(item => this.groupId === item.id)
        this.groupIndex = groupIndex === -1 ? 0 : groupIndex
        this.loading = false
      },

      // 加载商品列表
      async handleLoadData({ pageNumber }) {
        return this.groupData[this.groupIndex].useSearchApi
          ? apiSearchMartSearchSearchCommodity({
              pageIndex: pageNumber,
              pageSize: 15,
              refMartId: currentMall.mall_id,
              refMerchantId: '',
              categoryIds: this.groupData[this.groupIndex].searchCategoryIds,
              categoryParams: {},
              inStockFlag: false,
              promoteFlag: false,
              minPrice: 0,
              maxPrice: 99999,
              sceneId: '55f9be7e73c04949bfa7a0c850d33924',
              searchWord: '',
              sortType:
                // 综合
                this.filterForm.orderBy === 'none'
                  ? '02'
                  : // 价格
                  this.filterForm.orderBy === 'price'
                  ? this.filterForm.orderType === 'desc'
                    ? '04'
                    : '03'
                  : // 销量
                  this.filterForm.orderType === 'desc'
                  ? '01'
                  : '00',
            })
          : apiCommodityCommodityGroupCommodityList({
              id: this.id,
              classifyId: this.groupData[this.groupIndex].id,
              pageIndex: pageNumber,
              pageSize: 15,
              priceSortType:
                this.filterForm.orderBy !== 'price'
                  ? 0
                  : this.filterForm.orderType === 'asc'
                  ? 1
                  : 2,
              salesSortType:
                this.filterForm.orderBy !== 'sales'
                  ? 0
                  : this.filterForm.orderType === 'asc'
                  ? 1
                  : 2,
            })
      },

      // 点击搜索
      handleSearchClick() {
        navigateTo('SearchEntry')
      },
    },
  })
</script>

<style lang="scss" scoped>
  .header {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;

    .back {
      flex-shrink: 0;
      display: inline-flex;
      padding: 9px;
      border-radius: 1000px;
      background-color: transparent;
      color: white;

      .icon {
        flex-shrink: 0;
        font-size: 16px;
        display: inline-flex;
      }

      &:active {
        filter: contrast(0.9);
      }
    }

    .title {
      flex-grow: 1;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #222222;
    }

    .search {
      flex-shrink: 0;
      display: inline-flex;
      padding: 9px;
      border-radius: 1000px;
      background-color: white;

      .icon {
        flex-shrink: 0;
        font-size: 16px;
        display: inline-flex;
      }

      &:active {
        filter: contrast(0.9);
      }
    }
  }

  .headImage {
    position: relative;
    font-size: 0;
    z-index: 1;

    .cover {
      width: 100%;
      height: 160px;
      object-fit: cover;
    }
  }

  .searchBar {
    background-color: #f5f5f5;

    .groupBar {
      position: relative;
      background-color: white;
      overflow: hidden;

      .tabs {
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .icon {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            overflow: hidden;
          }

          .name {
            margin-top: 4px;
            font-size: 12px;
            white-space: nowrap;
          }
        }
      }

      .more {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 52px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        box-shadow: -2px 0px 9px 0px rgb(158 158 158 / 11%);
        z-index: 1;

        &:active {
          filter: contrast(0.9);
        }
      }

      ::v-deep {
        .van-tabs__wrap {
          height: 71px;
        }

        .van-tab {
          flex: unset;
          padding: 0 12px;

          &:nth-last-child(2) {
            flex-shrink: 0;
            width: 52px;
            padding: 0;
            pointer-events: none;
            opacity: 0;
          }
        }

        .van-tabs__nav {
          padding-right: 0;
          padding-left: 0;
        }

        .van-tabs__line {
          background: #ff111c;
        }

        .van-tab__text {
          font-size: 12px;
          font-weight: normal;
          color: #666666;
        }

        .van-tab--active .van-tab__text {
          font-size: 12px;
          color: #ff111c;
        }
      }
    }

    .filterBar {
      &:not(:first-child) {
        margin-top: 8px;
      }
    }
  }

  .pickGroupItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 6px;
    text-align: center;
    word-break: break-all;

    .icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 2px solid transparent;
    }

    .name {
      margin-top: 6px;
      font-size: 12px;
      color: #666666;
    }

    &.picked {
      .icon {
        border-color: #ff111c;
      }

      .name {
        color: #ff111c;
      }
    }
  }

  .goodsList {
    padding: 12px;
  }
</style>
